import React from 'react';
import classNames from 'classnames';
import { useRouter } from 'next/navigation';
import Image from 'next/image';

import { Avatar, SelectField } from '@/design-system';

type UserData = {
  imageUrl?: string;
  fullName?: string;
};

type LogoutItem = { label: string; href: string };

type UserMenuItem = LogoutItem & { value: 'logout' };

export interface SidebarUserMenuProps {
  collapsed?: boolean;
  user?: UserData;
  logoutItem?: LogoutItem;
}

export const SidebarUserMenu: React.FC<SidebarUserMenuProps> = ({ user, logoutItem }) => {
  const router = useRouter();

  const items: UserMenuItem[] = logoutItem ? [{ ...logoutItem, value: 'logout' }] : [];

  return (
    <SelectField<UserMenuItem, string>
      items={items}
      value={null}
      disabled={!logoutItem}
      className={classNames('px-0 py-0 w-full')}
      optionsClassName={classNames('left-6 right-6 z-50')}
      getValue={(i) => i.href}
      getLabel={(i) => i.label}
      renderValue={() => (
        <div
          className={classNames(
            'flex flex-row gap-4 items-center w-full rounded-md py-2 px-3',
            logoutItem && 'hover:bg-ds-bg-card-active cursor-pointer transition-colors',
          )}
        >
          <div className="flex justify-center items-center h-8">
            {!!user && (
              <Avatar
                size="s"
                text={user?.fullName}
                image={user?.imageUrl}
                className="transition-all duration-500 ease-in-out group-[.collapsed]/sidebar:w-6 group-[.collapsed]/sidebar:h-6"
              />
            )}
          </div>
          <span className="flex-1 min-w-0 truncate">{user?.fullName}</span>
        </div>
      )}
      renderOption={(i) => (
        <div className="flex gap-2 items-center px-2">
          <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
            <Image
              src="/img/logout.svg"
              alt=""
              width={20}
              height={20}
              aria-hidden="true"
              className="w-5 h-5"
            />
          </div>
          <div>{i.label}</div>
        </div>
      )}
      onChange={(_newValue, item) => {
        router.push(item.href);
      }}
    />
  );
};
